(()=>{
  const current=root=>root?.querySelector('[data-side].is-active')?.dataset.side||'front';
  const of=el=>el?.closest?.('[data-hfd-side]')?.dataset.hfdSide||current(el?.closest?.('[data-hfd]'));
  const nodes=(root,side,selector)=>{
    const name=side||current(root);
    return [...(root||document).querySelectorAll(`[data-hfd-side="${name}"] ${selector}`)];
  };
  window.hfdUi={
    current,
    of,
    nodes,
    pane(root,side){
      const name=side||current(root);
      return {
        side:name,
        layers:nodes(root,name,'[data-layer]'),
        rows:nodes(root,name,'[data-select-row]'),
        types:nodes(root,name,'[data-selection-type]'),
        values:nodes(root,name,'[data-flag-selection]'),
        zones:nodes(root,name,'[data-drag-zone]'),
        counts:nodes(root,name,'[data-count]'),
        crosses:nodes(root,name,'[data-cross]'),
        crossGrid:nodes(root,name,'[data-cross-grid]')[0],
        lines:nodes(root,name,'[data-lines]')[0],
        lineSize:nodes(root,name,'[data-line-size]')[0],
        lineColor:nodes(root,name,'[data-line-color]')[0],
        lineColorValue:nodes(root,name,'[data-line-color-value]')[0],
        lineOptions:nodes(root,name,'[data-line-options]')[0],
        preview:nodes(root,name,'[data-preview]')[0],
        scene:root?.querySelector(`.hfd__scene[data-hfd-side="${name}"]`)
      };
    }
  };
})();
